import { useState } from 'react';
import PropTypes from 'prop-types';
import { ModalHeaderWithActions, ModalBody, Modal } from '@evertrue/et-components';
import { formatCallTime } from './calls-table';
import ContactCard from 'apps/contact/components/contact-card/contact-card';
import CharacterCounter from 'apps/interactions/components/character-counter';

const MAX_CHARACTERS = 5000;

const CallNotesModal = ({ call = {}, onClose = () => {}, updateCall = () => {} }) => {
  const [callNotes, setCallNotes] = useState(call?.call_notes ?? '');
  const [isEditing, setIsEditing] = useState(false);

  const handleSubmit = async () => {
    await updateCall(call.id, { call_notes: callNotes.trim(), interaction_id: call.interaction_id });
    onClose();
  };

  const { formattedDate, formattedTime } = formatCallTime(call.created_at);

  return (
    <Modal isOpen={true}>
      <ModalHeaderWithActions
        title="Call Notes"
        closeModal={onClose}
        onSubmit={handleSubmit}
        disableSubmit={!isEditing || callNotes?.length > MAX_CHARACTERS}
        submitLabel={'Done'}
      />
      <ModalBody>
        <div>
          <ContactCard contact={call.contact} visibleData={['roleWithYear']} showNameLink={false} />
        </div>

        <div className="call-notes-modal--time">
          <h5 className="call-notes-modal--header">Call Date</h5>
          <div>{`${formattedDate} - ${formattedTime}`}</div>
        </div>

        <div>
          <h5 className="call-notes-modal--header">Call Notes</h5>
          <textarea
            className="call-notes-modal--textarea"
            value={callNotes}
            placeholder="Add Details..."
            onChange={(e) => setCallNotes(e.target.value)}
            onFocus={() => setIsEditing(true)}
          />
          <CharacterCounter limit={MAX_CHARACTERS} count={callNotes?.length || 0} />
        </div>
      </ModalBody>
    </Modal>
  );
};

export default CallNotesModal;

CallNotesModal.propTypes = {
  call: PropTypes.object,
  onClose: PropTypes.func,
  updateCall: PropTypes.func,
};
